const SITE_URL = "https://enter.abp.ua";
const SITE_NAME = "ABP Game";
const OG_IMAGE = `${SITE_URL}/og-image.png`;
const OG_IMAGE_WIDTH = 1066;
const OG_IMAGE_HEIGHT = 584;

const OPEN_GRAPH_BY_LANG = {
    ua: {
        htmlLang: "uk",
        locale: "uk_UA",
        title: "ABP Game — побудуй свій бізнес",
        description: "Пройди всі рівні гри та дізнайся, чи зможеш ти побудувати успішний бізнес.",
    },
    ru: {
        htmlLang: "ru",
        locale: "ru_RU",
        title: "ABP Game — построй свой бизнес",
        description: "Пройди все уровни игры и узнай, сможешь ли ты построить успешный бизнес.",
    },
    es: {
        htmlLang: "es",
        locale: "es_ES",
        title: "ABP Game — construye tu negocio",
        description: "Supera todos los niveles y descubre si lograrás construir un negocio exitoso.",
    },
};

export const getOpenGraphMeta = (lang, pathname) => {
    const data = OPEN_GRAPH_BY_LANG[lang] || OPEN_GRAPH_BY_LANG.ua;
    const localeAlternates = Object.values(OPEN_GRAPH_BY_LANG)
        .map(item => item.locale)
        .filter(locale => locale !== data.locale);

    const canonicalPath = pathname === "/" ? "/" : pathname.replace(/\/+$/, "") || "/";
    const url = canonicalPath === "/"
        ? `${SITE_URL}/`
        : `${SITE_URL}${canonicalPath}`;

    return {
        htmlLang: data.htmlLang,
        title: data.title,
        description: data.description,
        siteName: SITE_NAME,
        type: "website",
        url,
        locale: data.locale,
        localeAlternates,
        image: OG_IMAGE,
        imageWidth: OG_IMAGE_WIDTH,
        imageHeight: OG_IMAGE_HEIGHT,
    };
};
